import { FC } from "react";
import { MDSVerticalDividerProps } from "./vertical-divider.types";
import { StyledVerticalDivider } from "./vertical-divider.style";

export const MDSVerticalDivider: FC<MDSVerticalDividerProps> = ({ className }) => {
  return <StyledVerticalDivider className={className} />;
};
